import cn from 'classnames';
import { AdminListRowCell } from '../AdminListRowCell';
import { StyledAdminPoolConfigsListRow } from './styles';
import { IPoolConfig } from 'types';
import { Button } from 'components/shared';
import { useTranslation } from 'react-i18next';
import { AdminConfirmModal } from '../AdminConfirmModal';
import { useState } from 'react';

export interface IPoolConfigsListRowProps {
  children?: React.ReactNode;
  config: IPoolConfig;
  onChange: (updatedConfig: IPoolConfig) => void;
  onDelete: (poolId: number) => Promise<void>;
}

export const paymentFieldMap: Record<
  string,
  (payment: IPoolConfigsListRowProps['config']) => React.ReactNode
> = {
  name: (config) => config.name,
  host: (config) => config.host,
  port: (config) => config.port,
  algorithm: (config) => config.algorithm,
  user: (config) => config.user,
  password: (config) => config.password,
};

export const AdminPoolConfigsListRow = ({
  config,
  onChange,
  onDelete,
}: IPoolConfigsListRowProps) => {
  const { t } = useTranslation();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const closeConfirmModal = () => {
    setShowConfirmModal(false);
  };

  const submitDeletePoolConfigHandler = () => {
    setShowConfirmModal(true);
  };

  const submitDeletePoolConfigAction = async () => {
    onDelete(config.id);
    setShowConfirmModal(false);
  };

  return (
    <StyledAdminPoolConfigsListRow>
      <div className="admin-list-cell-container id">
        <AdminListRowCell>{config.id}</AdminListRowCell>
      </div>

      {Object.entries(paymentFieldMap).map(([title, valueGetter]) => (
        <div key={title} className={cn('admin-list-cell-container', title.toLowerCase())}>
          <AdminListRowCell>
            <input
              type="text"
              value={valueGetter(config) as string}
              onChange={(e) => onChange({ ...config, [title]: e.target.value })}
            />
          </AdminListRowCell>
        </div>
      ))}

      <div className="admin-list-cell-container actions">
        <AdminListRowCell>
          <Button
            title={t('adminPage.editPoolConfigs.delete')}
            onClick={submitDeletePoolConfigHandler}
          />
        </AdminListRowCell>
      </div>
      {showConfirmModal && (
        <AdminConfirmModal
          title={t('adminPage.confirmModal.deletePoolConfig')}
          onConfirm={submitDeletePoolConfigAction}
          onCancel={closeConfirmModal}
          show={showConfirmModal}
        />
      )}
    </StyledAdminPoolConfigsListRow>
  );
};
